<template>
  <router-link to="/login">
    <v-btn 
      v-show="!isLoggedIn"
      class="hidden-sm-and-down" 
      text 
    >
      <v-icon class="mr-4" dark>account_circle</v-icon>
      Login
    </v-btn>
  </router-link>
</template>

<script>
export default {
  name: "LoginButton",
  props: [
    "isLoggedIn"
  ]
}
</script>